/**
 * Given an object and a key of that object, returns true if that object's key
 * is writable. Useful for situations where one instance of an object is immutable,
 * but another is mutable, and if it's mutable, you need to do something with it.
 */
export function isPropertyWritable<T extends {}>(
  obj: T,
  key: keyof T
): boolean {
  const desc = Object.getOwnPropertyDescriptor(obj, key);
  return Boolean(desc?.writable);
}
